import { computed } from 'vue';

import { useStore } from './store.composable';
import { VEHICLE_CATEGORY } from '../models/constants';

declare const DealerLocator: any;

const useDealerLocator = () => {
  const { state, getter } = useStore();
  // ----------------------------------------
  // methods

  const joinVehicleTypeStrings = (selectedVehicleType: any): string => {
    return selectedVehicleType && selectedVehicleType.length
      ? selectedVehicleType.sort().join('_')
      : '';
  };

  const generateVehicleTypeSuffix = (selectedVehicleType: any): string => {
    return selectedVehicleType && selectedVehicleType.length
      ? `_${joinVehicleTypeStrings(selectedVehicleType)}`
      : '';
  };

  const getProfileNameByModel = ({ categories }: any, config: any): string => {
    if (categories?.length === 1) {
      if (VEHICLE_CATEGORY.COMMERCIAL === categories[0]) {
        return config.searchProfile.commercial;
      }
      return config.searchProfile.private;
    }

    if (
      categories?.includes(VEHICLE_CATEGORY.COMMERCIAL) &&
      categories.includes(VEHICLE_CATEGORY.PRIVATE)
    ) {
      return config.searchProfile.privateAndCommercial;
    }
    return config.searchProfile.private;
  };

  const dealerSearchResources = computed(() => {
    return [
      state.configuration.dealerSearch.resources.css,
      state.configuration.dealerSearch.resources.js,
    ];
  });

  const getSearchProfileName = (
    config: any,
    modelMapping: any,
    { model, selectedVehicleType }: any
  ): any => {
    const innerDealerSearchConfig: any = Object.assign({}, config);
    let specificProfile: any | undefined;
    const modelId = model.id + generateVehicleTypeSuffix(selectedVehicleType);
    if (modelMapping) {
      specificProfile = modelMapping.find(
        (mapping: any) => modelId === mapping.id
      );
    }
    if (!specificProfile) {
      specificProfile = modelMapping.find(
        (mapping: any) =>
          joinVehicleTypeStrings(selectedVehicleType) === mapping.id
      );
    }
    innerDealerSearchConfig.searchProfileName =
      (specificProfile &&
        specificProfile.dealerSearch.config.searchProfileName) ||
      getProfileNameByModel(model, config);

    return innerDealerSearchConfig;
  };

  const getWidgetBaseConfig = (
    { langCode, countryCode, market, modelMapping }: any,
    selection: any,
    dealerSearchConfig: any
  ): any => {
    return Object.assign(
      {},
      {
        language: `${langCode}_${countryCode}`,
        market,
      },
      getSearchProfileName(dealerSearchConfig, modelMapping, selection)
    );
  };

  const initWidget = async (element, outletId) => {
    const {
      dealerSearch: {
        config: { apiKey },
      },
      market,
    } = state.configuration;
    const language = getter.localeCode.replace('-', '_');
    const settings = {
      applicationID: 'OTDB',
      element,
      language,
      market,
      apiKey,
      outletId,
      configId: 'OneDLC_OTDB_DealerCard',
      height: 'auto',
      selectDealerCallback: () => {
        console.log('Need to create configuration');
      },
    };
    const dsw = await new DealerLocator(settings);
    dsw.init();
  };

  return {
    joinVehicleTypeStrings,
    generateVehicleTypeSuffix,
    dealerSearchResources,
    initWidget,
    getWidgetBaseConfig,
    getSearchProfileName,
    getProfileNameByModel,
  };
};

export default useDealerLocator;
